import { useProfile } from '../app-context';
import { sources } from '../data/content';
import { profileInfo } from '../domain/profiles';
import { PageHeading } from '../components/Primitives';
import { Icon } from '../components/Icon';
import metadata from '../../package.json' with { type: 'json' };

export function Sources() {
  const content = useProfile();
  const info = profileInfo(content.profile);
  const { official: officialQuestions, situations } = content;
  return (
    <>
      <PageHeading
        eyebrow="LA CONFIANCE COMMENCE PAR LA TRANSPARENCE"
        title="Des repères. Des sources. Pas de confusion."
        description="RCIVIC+ est une application indépendante de préparation à l’examen civique (CSP, CR, naturalisation), sans affiliation gouvernementale."
      />
      <div className="content-types">
        <article className="card">
          <span className="tag tag-blue">QUESTION OFFICIELLE</span>
          <h2>L’énoncé publié</h2>
          <p>
            Repris de la liste ministérielle {info.shortName}. {officialQuestions.length} énoncés
            sont intégrés pour ce profil, sur {content.officialTotal} énoncés dans la liste
            officielle.{' '}
            {!content.officialTotal &&
              'La liste officielle de ce profil n’est pas encore intégrée.'}
          </p>
        </article>
        <article className="card">
          <span className="tag">CONTENU PÉDAGOGIQUE</span>
          <h2>Pour mieux comprendre</h2>
          <p>
            Les réponses rédigées, résumés et explications sont créés par RCIVIC+ à partir de
            sources institutionnelles. Ce n’est pas un corrigé officiel.
          </p>
        </article>
        <article className="card">
          <span className="tag tag-training">EXERCICE D’ENTRAÎNEMENT</span>
          <h2>Pour mettre en pratique</h2>
          <p>
            Les propositions QCM et les {situations.length} situations originales sont pédagogiques.
            Les situations officielles de l’examen ne sont pas publiées.
          </p>
        </article>
      </div>
      <section className="notice">
        <Icon name="shield" />
        <p>
          <strong>Un premier lot, pas encore le corpus complet.</strong>
          <br />
          Vérification documentaire le 11 octobre 2026. Revue éditoriale humaine non attestée. Les
          scores de l’application ne garantissent pas la réussite à l’examen.
        </p>
      </section>
      <section className="sources-list">
        <h2>Les références consultées</h2>
        {sources.map((source) => (
          <article className="source-card" key={source.id}>
            <span className="icon-tile blue">
              <Icon name="link" size={20} />
            </span>
            <div>
              <span className="eyebrow">{source.organization}</span>
              <h3>
                <a href={source.url} target="_blank" rel="noreferrer">
                  {source.title}
                  <span className="sr-only"> — nouvelle fenêtre</span>
                </a>
              </h3>
              <p>
                Consultée le {new Date(`${source.checkedAt}T12:00:00`).toLocaleDateString('fr-FR')}
                {source.updatedAt
                  ? ` · mise à jour indiquée : ${new Date(`${source.updatedAt}T12:00:00`).toLocaleDateString('fr-FR')}`
                  : ' · date de modification non indiquée'}
              </p>
              <small>{source.license}</small>
            </div>
          </article>
        ))}
      </section>
      <section className="card">
        <h2>Votre confidentialité</h2>
        <p>
          Pas de compte obligatoire, de publicité ni de suivi analytique. Aucune donnée
          administrative n’est demandée. Votre progression est conservée sur cet appareil.
          L’ouverture d’un lien externe vous amène sur le site de la source, avec ses propres règles
          de confidentialité.
        </p>
        <h2>À propos de cette version</h2>
        <p>
          RCIVIC+ {metadata.version} · parcours introductif. Les graphismes sont originaux et les
          énoncés sont attribués au ministère de l’Intérieur. Les références client sont préservées
          ; aucune réponse non vérifiée n’est présentée comme officielle.
        </p>
      </section>
    </>
  );
}
